import React, { useEffect, useState } from "react";
import { fechaActual } from "../../../hooks/UseDate";
import { postDescripcionQuirurgicaEstadoConfirmado } from "../../../services/PaginaRuta";
import Loading from "../../Loading";
import { useLocation } from 'react-router-dom';

//import ModalSeleccioneMedicoCirugia from "./ModalSeleccioneMedicoCirugia";
import TablaDescripcionQuirurgicaDQ from "./TablaDescripcionQuirurgicaDQ";
import axios from "axios";
import { UserTokenURL } from "../../../services/ApiHIS";
import ErrorEndpointComponent from "../../Error/ErrorEndpointComponent";

const DescripcionQuirurgica = () => {
  //const [modalOnSeleccionMedicoCirugia, setmodalOnSeleccionMedicoCirugia] = useState(false);
  const [dataDescripcionQuirurgica, setdataDescripcionQuirurgica]= useState([])
  const [loading, setLoading]=useState(false)
  const [actualizaDQ, setactualizaDQ]=useState([])
  const [dataUserMedico, setdataUserMedico]=useState({})
  const [errorEndpoint, seterrorEndpoint]=useState(false)
 

  //identificar el usuario que ingreso
  //const  { token }  = useParams(); // Obtén el valor de los parámetros de la URL
  //TOKEN
  let query = new URLSearchParams(useLocation().search);
    let tokenCons = JSON.parse(query.get('token'));
    let location = useLocation();
  useEffect(() => {
    // Google Analytics
    //localStorage.removeItem('tokenReact');
    localStorage.setItem('tokenReact',tokenCons)
  }, [location]);

    useEffect(()=>{
      //console.log(tokenCons,'tokenConstokenCons')
      const url = UserTokenURL()
  
      // Configurar la cabecera con el token JWT
      const headers = {
        Authorization: `Bearer ${tokenCons}`,
      };
  
      // Realiza la petición con Axios
      axios.get(url, { headers })
      .then(response => {
        //console.log(response.data.user_data, 'data user');
        setdataUserMedico(response.data.user_data)
        // Si decides actualizar el localStorage, primero elimina los datos antiguos si es necesario
        localStorage.removeItem('usuarioInfo');
        console.log(localStorage.getItem('usuarioInfo'), 'antes data user')
        // Guarda los nuevos datos
        localStorage.setItem('usuarioInfo', JSON.stringify(response.data.user_data));
  
        //console.log(localStorage.getItem('usuarioInfo'),'antessss')
        // Comprobación de los datos almacenados
        const usuarioInfo = JSON.parse(localStorage.getItem('usuarioInfo'));
        console.log(usuarioInfo.tipoUsuario, 'usuarioInfoStr')
  
        // Resto del código...
      })
      .catch(error => {
        console.error('Error al autenticar al usuario:', error);
        //seterrorEndpoint(true)
      });
    },[])


  const handleOnsubmitBuscar=(e)=>{
    e.preventDefault()
    
    setLoading(false)
    const body={
      ProFec: e.target.fechab.value,
     // ProEsta: e.target.estadosSelect.value,
      //ProEsta:'2',
      //ProSedQr:'001',
      MPCedu: e.target.userId.value
    }
    //console.log(body,'bodyyyyyyy')
    postDescripcionQuirurgicaEstadoConfirmado(body).then((res)=>{
      //console.log(res.data)   
      if(res.data.error){
        setdataDescripcionQuirurgica([])
        setLoading(true)
      } else{
        setTimeout(() => {          
          setLoading(true)
        }, 1500);
        let arrayUser =res.data        
        let filtradoEstado = arrayUser.filter(objeto => 
          {
            if(objeto.ultimoEstado === "salida" || objeto.ultimoEstado === "recuperacion"){

            }
            else {return (objeto.ProEsta === "4" || objeto.ultimoEstado === "cirugia")}

          })
          setdataDescripcionQuirurgica(filtradoEstado)
      }  
      
    })
    .catch(error => {
      //console.error('Error al autenticar al usuario:', error);
      //seterrorEndpoint(true)
      setLoading(true)
    });
    
  }

  const passDataActualizarDescripcionQX=(data)=>{
    setactualizaDQ(data)
  }

  useEffect(()=>{
    const body={
      ProFec:fechaActual(),
      //ProEsta:'2',
      //ProSedQr:'001'
    }


    
    postDescripcionQuirurgicaEstadoConfirmado(body).then((res)=>{
      //console.log(res.data,'mirar bien')
      if(res.data.error){
        setdataDescripcionQuirurgica([])
        setLoading(true)
      }else{
          
          setTimeout(() => {          
            setLoading(true)
        }, 1500);
        let arrayUser =res.data        
        let filtradoEstado = arrayUser.filter(objeto => 
          {
            if(objeto.ultimoEstado === "salida" || objeto.ultimoEstado === "recuperacion"){

            }
            else {return (objeto.ProEsta === "4" || objeto.ultimoEstado === "cirugia")}

          })
        setdataDescripcionQuirurgica(filtradoEstado)
      }
      
    })
    .catch(error => {
      //console.error('Error al autenticar al usuario:', error);
      //seterrorEndpoint(true)
      setLoading(true)
    });
  },[actualizaDQ])

 

  return (
    <>
    <div className="">
      <div className=" text-2xl text-[#9e56fe] font-medium pb-3">
        Descripción Quirúrgica
      </div>
      {/* <div className="text-center bg-[#05a29d] pb-1">
          <label
            htmlFor="exampleFormControlInput1"
            className="form-label inline-block mt-1 text-white font-medium px-1 text-xl "
          >
            Filtros de Búsqueda
          </label>
        </div> */}

      <form onSubmit={handleOnsubmitBuscar}>
        <div className="flex ">
          <div className="mb-3 xl:w-96">
            <label
              htmlFor="exampleFormControlInput1"
              className="form-label inline-block mb-2 text-gray-900 font-medium"
            >
              Número de documento de identidad
            </label>
            <div className="flex">
              <input
                name="userId"
                type="text"
                className="form-control block  w-full px-3 py-1.5 text-base font-normal  text-gray-900 bg-white bg-clip-padding border border-solid border-gray-300
                          rounded transition  ease-in-out m-0  focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                id="exampleFormControlInput1"
                placeholder=""
              />
            </div>
          </div>
          
          
          
          <div className="mb-3 pl-2">
            <label
              htmlFor="exampleFormControlInput1"
              className="form-label inline-block mb-2 text-gray-900 font-medium"
            >
              Fecha
            </label>
            <div className="flex">
              <div className="flex items-center justify-center">
                <div className="datepicker relative form-floating mb-3 xl:w-96">
                  <input
                    defaultValue={fechaActual()}
                    type="date"
                    name="fechab"
                    className="form-control block w-full px-3 py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                    placeholder="Select a date"
                  />
                </div>
              </div>

              <div className="px-3">
                <button
                  type="submit"
                  className="inline-block px-6 py-2.5 bg-[#9e56fe] text-white font-medium text-xs leading-tight uppercase rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out"
                >
                  Buscar
                </button>
              </div>
            </div>
          </div>
        </div>
        <div className="w-3/3  px-1 flex">
                  <label className="form-label inline-block mb-2 text-gray-900 font-medium">
                  Se diligenció la descripción quirúrgica, la nota del Anestesiólogo y la nota Instrumentador
                  </label>
                  <div className="px-2">
                    <input
                      //   onChange={searchUserId}
                      //defaultValue={props.userDate[0].ProEmpCod}
                      //defaultValue={informacionUser.MPCedu}
                      //name="especialidadMedico"
                      disabled={true}
                      type="text"
                      autoComplete="off"
                      className="form-control block w-20 px-2 py-0.5 text-base font-normal  text-gray-900  bg-[#a7f3d0] bg-clip-padding    transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                      id="exampleFormControlInput1"
                      placeholder=""
                    />
                    
                  </div>
                  {/* <label className="form-label inline-block  text-gray-900 font-medium">
                  Diligenció la descripción qx
                  </label>
                  <div className="pb-6">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" width="24px" height="56px" fill="black">
              
              <path d="M224 256A128 128 0 1 0 224 0a128 128 0 1 0 0 256zm-96 55.2C54 332.9 0 401.3 0 482.3C0 498.7 13.3 512 29.7 512H418.3c16.4 0 29.7-13.3 29.7-29.7c0-81-54-149.4-128-171.1V362c27.6 7.1 48 32.2 48 62v40c0 8.8-7.2 16-16 16H336c-8.8 0-16-7.2-16-16s7.2-16 16-16V424c0-17.7-14.3-32-32-32s-32 14.3-32 32v24c8.8 0 16 7.2 16 16s-7.2 16-16 16H256c-8.8 0-16-7.2-16-16V424c0-29.8 20.4-54.9 48-62V304.9c-6-.6-12.1-.9-18.3-.9H178.3c-6.2 0-12.3 .3-18.3 .9v65.4c23.1 6.9 40 28.3 40 53.7c0 30.9-25.1 56-56 56s-56-25.1-56-56c0-25.4 16.9-46.8 40-53.7V311.2zM144 448a24 24 0 1 0 0-48 24 24 0 1 0 0 48z"/>
              </svg>
                    
                  </div> */}
                </div>
      </form>
      {/* <label
        htmlFor="exampleFormControlInput1"
        className="form-label block mb-2 text-gray-900 font-medium"
      >
        Descripción Quirúrgica
      </label>
      <button
        type="button"
        onClick={handleOnclickSeleccionMedicoCirugia}
        className="inline-block px-6 py-2.5 bg-blue-600 text-white font-medium text-xs leading-tight uppercase rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out"
      >
        Descripción Quirúrgica
      </button> */}
      {/* <div className="mb-3 xl:w-96">
          <label
            htmlFor="exampleFormControlInput1"
            className="form-label inline-block mb-2 text-gray-900 font-medium"
          >
            Programación de Cirugía
          </label>
          <div className="flex">
          <div className="">
              <button
                //onClick={handleOnclickModalOnProgramacionDeCirugia}
                type="button"
                className="inline-block px-6 py-2.5 bg-blue-600 text-white font-medium text-xs leading-tight uppercase rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out"
              >
                Programación
              </button>
            </div>
          </div>
        </div> */}
      <div className="flex flex-col">
            <div className="overflow-x-auto md:overflow-x-visible sm:overflow-x-visible">
                <div className="py-2 inline-block min-w-full">
                <div className="overflow-auto md:overflow-visible">
                    <table className="min-w-full text-center bg-gray-200">
                <thead className=" ">
                  <tr>
                  <th
                      
                    >
                      
                    </th>
                    <th
                      scope="col"
                      className="text-sm font-medium text-gray-900 px-4 py-2"
                    >
                      Descripción Quirúrgica
                    </th>
                    <th
                      scope="col"
                      className="text-sm font-medium text-gray-900 px-4 py-2"
                    >
                      Nota Instrumentador
                    </th>
                    <th
                      scope="col"
                      className="text-sm font-medium text-gray-900 px-4 py-2"
                    >
                      Nota Anestesiólogo 
                    </th>
                    <th
                      scope="col"
                      className="text-sm font-medium text-gray-900 px-4 py-2"
                    >
                      
                    </th>
                    <th
                      scope="col"
                      className="text-sm font-medium text-gray-900 px-4 py-2"
                    >
                      Cns
                    </th>
                    <th
                      scope="col"
                      className="text-sm font-medium text-gray-900 px-4 py-2"
                    >
                      Fecha
                    </th>
                    <th
                      scope="col"
                      className="text-sm font-medium text-gray-900 px-4 py-2"
                    >
                      Cd. Sala
                    </th>
                    <th
                      scope="col"
                      className="text-sm font-medium text-gray-900 px-4 py-2"
                    >
                      Sala
                    </th>
                    <th
                      scope="col"
                      className="text-sm font-medium text-gray-900 px-4 py-2"
                    >
                      Id. Paciente
                    </th>
                    <th
                      scope="col"
                      className="text-sm font-medium text-gray-900 px-4 py-2"
                    >
                      Doc
                    </th>
                    <th
                      scope="col"
                      className="text-sm font-medium text-gray-900 px-4 py-2"
                    >
                      Edad
                    </th>
                    <th
                      scope="col"
                      className="text-sm font-medium text-gray-900 px-4 py-2"
                    >
                      Ctvo. Ingreso
                    </th>
                    <th
                      scope="col"
                      className="text-sm font-medium text-gray-900 px-4 py-2"
                    >
                      Nombre Paciente
                    </th>
                    <th
                      scope="col"
                      className="text-sm font-medium text-gray-900 px-4 py-2"
                    >
                      
                    </th>
                    {/* <th
                      scope="col"
                      className="text-sm font-medium text-gray-900 px-4 py-2"
                    >
                      
                    </th> */}
                  </tr>
                </thead>
                
                  {
                    loading?
                    dataDescripcionQuirurgica.map((item,index)=>(
                      <TablaDescripcionQuirurgicaDQ key={index} item={item} dataUserMedico={dataUserMedico} passDataActualizarDescripcionQX={passDataActualizarDescripcionQX}/>
                    ))
                    :
                    <tbody >
                    <tr className="divide-y divide-slate-700">
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td><Loading/></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                    </tr>
                    </tbody>
                  }
                
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
    {errorEndpoint && <ErrorEndpointComponent seterrorEndpoint={seterrorEndpoint} />}
    {/* {modalOnSeleccionMedicoCirugia? <ModalSeleccioneMedicoCirugia setmodalOnSeleccionMedicoCirugia={setmodalOnSeleccionMedicoCirugia}/>:null} */}
    </>
  );
};

export default DescripcionQuirurgica;
